import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=0fc089b3&scoped=true"
import script from "./footer.vue?vue&type=script&setup=true&lang=js"
export * from "./footer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=0fc089b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc089b3",
  null
  
)

export default component.exports